import React, { useState, useEffect } from "react";
import * as httpClient from "../../../util/httpClient";
import { useDispatch } from "react-redux";
import * as secureStorageActions from "../../../store/secureStorageService/actions";
import { Notification } from "../../common/Notification";
import { useTranslation } from "react-i18next";

const ConfirmDeleteFilesDialog: React.FunctionComponent<{ fileItem: any; closeDialog(): void }> = (props) => {
    const { t: tLang, i18n: i18nLang } = useTranslation();
    const [isLoading, setisLoading] = useState(false);
    const dispatch = useDispatch();
    const requestData = () => dispatch(secureStorageActions.actionCreators.getDocumentsAndImagesData());

    const closeDialog = () => {
        document.body.classList.remove("no_scroll");
        props.closeDialog();
    };

    const refresWalletItem = () => {
        closeDialog();
        requestData();
    };

    const deleteItem = () => {
        const requestBody = {
            "vault-id": props.fileItem.id,
        };
        setisLoading(true);
        httpClient
            .sendRequest("POST", `api/securevault/deleteSecureFiles`, requestBody)
            .then((data) => {
                setisLoading(false);
                if (data.Status) {
                    Notification({
                        type: "success",
                        title: tLang("identityVault.secureStorage.documentsAndImagesWidget.fileDeleteToastTitle"),
                        message: props.fileItem.label + tLang("identityVault.secureStorage.documentsAndImagesWidget.fileDeleteToastMessaage"),
                    });
                    refresWalletItem();
                } else {
                    Notification({
                        type: "error",
                        title: tLang("identityVault.secureStorage.documentsAndImagesWidget.errorToastTitle"),
                        message: tLang("identityVault.secureStorage.documentsAndImagesWidget.errorToastMesage"),
                        duration: 0,
                    });
                    closeDialog();
                }
            })
            .catch(function (error) {
                setisLoading(false);
                Notification({
                    type: "error",
                    title: tLang("identityVault.secureStorage.documentsAndImagesWidget.errorToastTitle"),
                    message: tLang("identityVault.secureStorage.documentsAndImagesWidget.errorToastMesage"),
                    duration: 0,
                });
                closeDialog();
            });
    };

    return (
        <React.Fragment>
            {!isLoading ? (
                <>
                    <div className="dialog-header">
                        <div className="dialog-icon">
                            <em className="las la-trash"></em>
                        </div>
                        <h1>{tLang("identityVault.secureStorage.documentsAndImagesWidget.deleteItemPopup.title")}</h1>
                    </div>

                    <div className="dialog-body">
                        <p>
                            {tLang("identityVault.secureStorage.documentsAndImagesWidget.deleteItemPopup.message")} <strong>{props.fileItem.label}?</strong>
                        </p>
                    </div>

                    <div className="dialog-footer">
                        <div className="row between-xs">
                            <div className="col-xs col-no-gutter flex-grow-null">
                                <button type="button" className="btn-default btn-link btn-no-padding btn-no-border" onClick={() => closeDialog()}>
                                    <span className="btn-text">
                                        {tLang("identityVault.secureStorage.documentsAndImagesWidget.deleteItemPopup.cancelButtonText")}
                                    </span>
                                </button>
                            </div>
                            <div className="col-xs col-no-gutter flex-grow-null">
                                <button type="button" className="btn-default btn-red" onClick={() => deleteItem()}>
                                    <span className="btn-icon">
                                        <em className="las la-trash-alt"></em>
                                    </span>
                                    <span className="btn-text">
                                        {tLang("identityVault.secureStorage.documentsAndImagesWidget.deleteItemPopup.deleteButtonText")}
                                    </span>
                                </button>
                            </div>
                        </div>
                    </div>
                </>
            ) : (
                <div className="box loading"></div>
            )}
        </React.Fragment>
    );
};

export default ConfirmDeleteFilesDialog;
